export default __webpack_public_path__ + "static/media/iks.576f1d33.png";